import { IS_HIDE_PRO_MONTHLY_OPTION } from '@/features/flags/legacy-flags';
import { PeriodTabsList } from '@heidi/commerce';
import { type Period } from '@heidi/commerce/contracts';
import { FramedIcon } from '@heidi/design-system/framed-icon';
import { DialogDrawerHeader } from '@heidi/design-system/mobile-responsive-dialog-drawer';
import { SegmentedControl } from '@heidi/design-system/segmented-control';
import { TypographyH2, TypographyPBold } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';

interface ModalHeaderProps {
  period: Period;
  onPeriodChange: (period: Period) => void;
}

export function EndPromotedModalHeader({ period, onPeriodChange }: ModalHeaderProps) {
  const { t } = useTranslations();

  return (
    <DialogDrawerHeader className="flex flex-col items-center gap-4">
      <FramedIcon state="pro" />
      <div>
        <TypographyH2 className="text-center">
          {t('endPromotedTrialModal.title')}
        </TypographyH2>
        <TypographyPBold className="text-center text-text-secondary">
          {t('endPromotedTrialModal.description')}
        </TypographyPBold>
      </div>
      {!IS_HIDE_PRO_MONTHLY_OPTION() && (
        <SegmentedControl
          value={period}
          onValueChange={(newTabState) => onPeriodChange(newTabState as Period)}
          className="items-center"
        >
          <PeriodTabsList />
        </SegmentedControl>
      )}
    </DialogDrawerHeader>
  );
}
